import React from "react";

import { cx } from "@emotion/css";
import MuiCheckbox, { CheckboxClasses as MuiCheckboxClasses } from "@mui/material/Checkbox";

import { AtomProps, StyleClasses } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type BaseCheckboxProps = {
  checked: boolean;
  onChange?: (checked: boolean, event: React.ChangeEvent<HTMLInputElement>) => void;
  indeterminate?: boolean;
  disabled?: boolean;
  required?: boolean;
  name?: string;
  value?: string;
  size?: "small" | "medium";
};

type CheckboxStyleClasses = StyleClasses<keyof MuiCheckboxClasses>;

export type CheckboxProps = AtomProps<BaseCheckboxProps, CheckboxStyleClasses>;

export const Checkbox: React.FC<CheckboxProps> = ({ onChange, className, classes, ...props }) => (
  <MuiCheckbox
    {...props}
    onChange={(event, checked) => onChange?.(checked, event)}
    className={cx(className, classes?.root)}
  />
);
